module.exports = __webpack_public_path__ + "images/back-btn-e6f7aab0c7a78f59feba178c84aa746d.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/back-btn.svg
// module id = ./client/assets/images/back-btn.svg
// module chunks = 1 6 7 8 9